import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from 'projects/insight/src/app/routes/auth/auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { UiModule } from '@insight/ui';
import { AuthComponent } from './auth.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRoutingModule,
    UiModule,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  exports: [
    AuthenticateComponent
  ],
  providers: [
    AuthenticateComponent
  ],
  declarations: [
    AuthenticateComponent,
    AuthComponent
  ]
})
export class AuthModule { }
